import DepositFixedTermMaturitySettings from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/DepositFixedTermMaturitySettings";

export default class AccountDepositFixedTermMaturitySettings extends DepositFixedTermMaturitySettings {
    overridden: boolean = false;
}